export {default} from './ChatGenericTemplateMessage';
export * from './ChatGenericTemplateMessage';



// WEBPACK FOOTER //
// ./src/components/ChatUI/ChatGenericTemplateMessage/index.ts